import { editorFrameClient } from "../kernels/pages/editor/editorFrameClient";
import { Services } from "../kernels/types/Services";
import { createFrameClient } from "./createFrameClient";
import {
  adhocClient,
  analyticsClient,
  competitionsClient,
  datasetsClient,
  educationClient,
  kernelsClient,
  kernelStorageClient,
  searchClient,
  tagsClient,
  usersClient,
  userSecretsClient,
} from "./services";

/** Services are kept on a mutable object since the reference shouldn't change when runtime services are modified. */
let servicesMutable: Services;
/** Gets the current services object. */
export const getServices = (): Services => {
  if (!servicesMutable) {
    servicesMutable = {
      kernelsClient,
      competitionsClient,
      searchClient,
      usersClient,
      userSecretsClient,
      datasetsClient,
      analyticsClient,
      adhocClient,
      educationClient,
      kernelStorageClient,
      tagsClient,
      frameClient: createFrameClient(),
      jupyterClient: editorFrameClient,
    };
  }
  return servicesMutable;
};

/**
 * Updates the current services swapping out runtime updates.
 * All services are technically mutable to support unit testing.
 */
export const updateServices = (newServices: Services) => {
  if (servicesMutable && newServices) {
    Object.assign(servicesMutable, newServices);
  } else {
    servicesMutable = newServices || ({} as any);
  }
};

/** Shortcut to fetch the JupyterHandler */
export const getJupyterHandler = () => editorFrameClient;

/* Shortcut to fetch the analyticsClient logger */
export const getLogger = () => getServices().analyticsClient.logger;
